export const TYPE_MAPPING = { 
    Input: {
        entityType: 'Input'
    },
    CnBatchInput: {
        entityType: 'CnBatchInput'
    },
    NumberPicker: {
        entityType: 'NumberPicker'
    },
    RangeNumberPicker: {
        entityType: 'RangeNumberPicker'
    },
    Select: {
        entityType: 'SelectField'
    },
    RadioGroup: {
        entityType: 'SelectField'
    },
    CheckboxGroup: {
        entityType: 'SelectField'
    },
    DatePicker: {
        entityType: 'RangePickerField'
    },
    TimePicker: {
        entityType: 'RangePickerField'
    },
    RangePicker: {
        entityType: 'RangePickerField'
    },
    RangeTimePicker: {
        entityType: 'RangePickerField'
    },
    EmployeeSelect: {
        entityType: 'EmployeeSelect'
    },
    AddressSelect: {
        entityType: 'AddressSelect'
    },
    DepartmentSelect: {
        entityType: 'DepartmentSelect'
    },
    TreeSelect: {
        entityType: 'TreeSelect'
    },
    CascaderSelect: {
        entityType: 'CascaderSelect'
    },
    Compose: {
        entityType: 'Compose'
    },
    AutoComplete: {
        entityType: 'AutoComplete' 
    },
    default: {
        entityType: '' 
    }
}

export const getEntityType = (componentName) => {
    const config = TYPE_MAPPING[componentName] || TYPE_MAPPING.default;
    return config?.entityType;
}
